// extracted by mini-css-extract-plugin
export default {"stack-main-layout":"password_stack-main-layout__DEkqy","stack-auth-layout":"password_stack-auth-layout__FosTc","box-inputs":"password_box-inputs__apAsj"};